export const CLOSING_FR = {
  header: {
    title: 'Engagements',
    subtitle:
      'Cette section récapitule les <strong>talents qui ont accepté votre offre</strong>.<br/><br/>Selon les autorisations de votre compte, les détails des coûts et la documentation associée peuvent également être inclus.',
  },
  bingoHeader: {
    label: 'Vous avez embauché',
    sublabel: '',
  },
  links: {
    resignation_letter: 'Lettre de démission',
    commitment_letter: "Promesse d'embauche",
    prospect: 'Voir calcul',
  },
  tag: {
    text: 'Embauché/e le {{hiring_date}}',
  },
};
